<template>
<div class="chapter">
<div class="inner_page">
<p class="ct1"><a href="#/contents#t2" id="c2"><i>Author’s Note</i></a></p>
<p class="tx1">As a disclaimer, I know there are more stories out there and more books that will probably never see the light of day. Country Music singer Bill Anderson, the long-ago Country Music Association Entertainer of the Year, suggested to my agent, Stan Cooper, that a single book could never contain all the stories about Merle, and I think he’s right about that. It seems that everyone in the Nashville music business—especially the old-timers—has a Merle Kilgore story. That’s what made him legendary. If you hung around Merle long enough, you’d eventually have your own story to tell.</p>
<p class="tx">But you won’t find all those stories here. For that reason, I don’t claim that my version is the definitive Merle Kilgore story. All I can hope to do is give my own telling of it, a secondhand account through the eyes of his grandson. I should also point out that most of the stories in this book are Merle’s stories; I merely brought them all together.</p>
<p class="tx">On that note, allow me to quote the title of an Elton John album: <i>Don’t shoot me; I’m only the piano player</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authors_note.vue?d11e1f44